import '../styles/chatbot-landing.css';
import ChatBotInput from "./ChatBotInput";
import StartsIcon from "../assets/icons/stars.svg";
import ScopeIcon from "../assets/icons/scope_icon.svg";
import TrendingIcon from "../assets/icons/trending.svg";
import FujitsuUvanceLogo from "../assets/icons/Fujitsu_powered_by_uvance_icon.svg";

const ChatBotLanding = () => {

    return (
        <div className="chatbot-container">
            <div className="chatbot-container-content">
                <div className="chatbot-landing">
                <div className="chatbot-title-info">
                    <div className="icon-title">
                        <img src={FujitsuUvanceLogo} alt=""/>
                        <div className="title">
                            <div className="line"></div>
                            <h1>Sustainability AI Agent</h1>
                        </div>

                    </div>
                    <p className={"subtitle"}>Driving sustainable initiatives with an always-available expert</p>
                </div>
                <ChatBotInput inputNewChat={true}/>
                <div className="chatbot-extra-info">
                    <div className="extra-info">
                        <img src={StartsIcon} alt="" className={"icon"}/>
                        <h3 className="header">
                            Specialized Knowledge
                        </h3>
                        <p className="info">
                            Access trustworthy answers through an agent trained with extensive, up-to-date sustainability information
                        </p>
                    </div>
                    <div className="extra-info">
                        <img src={ScopeIcon} alt="" className={"icon"}/>
                        <h3 className="header">
                            Search and Consultation
                        </h3>
                        <p className="info">
                            Conduct in-depth queries to clarify concepts, resolve doubts, and gain both strategic and technical sustainability insights.
                        </p>
                    </div>
                    <div className="extra-info">
                        <img src={TrendingIcon} alt="" className={"icon"}/>
                        <h3 className="header">
                            Decision-Making Support
                        </h3>
                        <p className="info">
                            Receive practical guidance and recommendations to help you implement or enhance sustainability solutions in your workplace.
                        </p>
                    </div>

                </div>
            </div>
            </div>
        </div>
    )
}

export default ChatBotLanding;